module.exports = ".main-siderbar {\n    background: #34495E;\n}"